export default __webpack_public_path__ + "static/media/conciliacion.22bd78e0.svg";